// Live-leest 3 TOC-collecties (Stakeholders / Activities / OutputEffects) en
// checkt of er minstens één compleet pad bestaat:
//
//   Stakeholder ←(Activity.Targetgroup)— Activity ←(OutputEffect.Activity)— Effect
//
// PERF: deze hook is duur (3 live snapshots). Roep 'm alleen aan vanuit een
// component dat zelf gegated is op `subscription.modules.impactMeten` — anders
// abonneert elke caller voor élke org, ook orgs zonder impactMeten.
// Voorbeeld: TOCProgressBanner gebruikt een outer/inner-split waarbij de inner
// (die deze hook aanroept) alleen mount wanneer impactMeten aan staat.
//
// Drives:
//   - `TOCProgressBanner` (top-of-app banner)
//   - Decca's TOCOnboarding subject-handler (inputs voor de AI-prompt)
//
// Spec: docs/features/onboarding-flow.md sectie "AI TOC-strategie".

import { useFirestore } from '../firebase/useFirestore'
import hasCompleteTOCChain from '../helpers/tocHelpers/hasCompleteTOCChain'

const useTOCProgress = () => {

    const stakeholders = useFirestore('Stakeholders')
    const activities = useFirestore('Activities')
    const effects = useFirestore('OutputEffects')

    const ready = Array.isArray(stakeholders)
        && Array.isArray(activities)
        && Array.isArray(effects)

    if (!ready) {
        return { hasCompleteChain: false, missing: {}, loading: true }
    }

    const result = hasCompleteTOCChain({ stakeholders, activities, effects })

    return {
        ...result,
        loading: false,
        counts: {
            stakeholders: stakeholders.length,
            activities: activities.length,
            effects: effects.length,
        },
    }

}

export default useTOCProgress
